import Rails from '@rails/ujs'

Rails.delegate(document, '[name=select_all]', 'click', event => {
  let select_all = !!event.target.checked

  document.querySelectorAll('form [type=checkbox]:not(:disabled)').forEach(checkbox => {
    checkbox.checked = select_all
  })
})
